var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls,style:({ width: _vm.barWidth, transition: '0.3s all' })},[_c('div',{staticStyle:{"float":"left"}},[_vm._t("extra",function(){return [_vm._v(_vm._s(_vm.extra))]})],2),_c('div',{staticStyle:{"float":"right"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }